import PaymanGet from './Get'
import PaymanCreate from './Create'
import PaymanUpdate from './Update'
import PaymanDetails from './Details'

export {
    PaymanGet,
    PaymanCreate,
    PaymanUpdate,
    PaymanDetails,
}